/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { IImageProps, IImageSettings, Image } from '@msdyn365-commerce/core';
import { CartLine, SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';
import * as React from 'react';

/**
 * The cartLine product interface.
 */
export interface ICartLineWithProduct {
    cartLine: CartLine;
    product?: SimpleProduct;
}

/**
 * The checkout shipping cartLine interface.
 */
export interface ICheckoutShippingCartLineInfo {
    lineId?: string;
    imageProps: IImageProps;
    deliveryMethodDesc?: string;
    requestDeliveryDate?: string;
}

/**
 * The checkout shipping cartLine props.
 */
export interface ICheckoutShippingCartLinesProps {
    moduleClassName: string;
    cartLines: ICheckoutShippingCartLineInfo[];
}

// eslint-disable-next-line @typescript-eslint/naming-convention -- Following as per module
export const CheckoutShippingCartLines: React.FC<ICheckoutShippingCartLinesProps> = ({ moduleClassName, cartLines }) => {
    if (!ArrayExtensions.hasElements(cartLines)) {
        return null;
    }

    return (
        <div className={`${moduleClassName}__group-images`}>
            <div className={`${moduleClassName}__group-images-lines`}>
                {cartLines.map((cartLine: ICheckoutShippingCartLineInfo) => {
                    const className = `${moduleClassName}__group-images-lines-product`;
                    return (
                        <div className={className} key={cartLine.lineId}>
                            <Image {...cartLine.imageProps} />
                            <div className='ms-checkout-shipping-address__group-images-header-item'>{cartLine.deliveryMethodDesc}</div>
                            <div></div>
                            <div className='ms-checkout-shipping-address__group-images-header-item'>{cartLine.requestDeliveryDate}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

/**
 * The checkout shipping cartLine image settings.
 */
export const defaultImageSettings: IImageSettings = {
    viewports: {
        xs: { q: 'w=108&h=108&q=80&m=6&f=jpg', w: 108, h: 108 },
        lg: { q: 'w=108&h=108&q=80&m=6&f=jpg', w: 108, h: 108 },
        xl: { q: 'w=108&h=108&q=80&m=6&f=jpg', w: 108, h: 108 }
    },
    lazyload: true,
    quality: 80
};
